import { ValueFormatterParams } from 'ag-grid-community';
import { CustomCellEditorProps, CustomCellRendererProps } from 'ag-grid-react';
import { OrderType } from 'apiConnector/secondary-market/batch/model';
import { RowData, SecondaryBatchColumnDefinition } from 'state/workspaces/secondary-market/batch/model';
import { ApiLevel } from 'utils/http/httpClient.model';

export type TimeUnit =
  | 'Nanosecond'
  | 'Microsecond'
  | 'Millisecond'
  | 'Second'
  | 'Minute'
  | 'Hour'
  | 'Day'
  | 'Week'
  | 'Month'
  | 'Quarter'
  | 'Year';

export type SemanticBoundary = {
  unit: TimeUnit;
  start: number;
  end: number;
  level: ApiLevel;
};

export type SemanticMetadata = SemanticBoundary[];

export type Context = { orderType: OrderType };
export type SecondaryCellRendererProps<TValue extends RowData[keyof RowData]> = Omit<
  CustomCellRendererProps<RowData, TValue, Context>,
  'colDef'
> & {
  colDef: SecondaryBatchColumnDefinition;
};

export type SecondaryCellEditorProps<TValue extends RowData[keyof RowData]> = Omit<
  CustomCellEditorProps<RowData, TValue, Context>,
  'colDef'
> & {
  colDef: SecondaryBatchColumnDefinition;
};

export type SecondaryValueFormatterParams<Value> = Omit<ValueFormatterParams<RowData, Value>, 'colDef'> & {
  colDef: SecondaryBatchColumnDefinition;
};

export type SecondaryCellProps<TValue extends RowData[keyof RowData]> =
  | (SecondaryCellRendererProps<TValue> & { type: 'renderer' })
  | (SecondaryCellEditorProps<TValue> & { type: 'editor' });

export function asSecondaryCellEditorProps<TValue extends RowData[keyof RowData]>(
  cell: Pick<SecondaryCellProps<TValue>, 'type'>,
) {
  return cell as Partial<
    Pick<SecondaryCellEditorProps<TValue>, 'stopEditing' | 'eventKey' | 'rowIndex' | 'onValueChange' | 'initialValue'>
  >;
}
